// src/components/modals/ReservationChoiceModal.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ReservationChoiceModal({ open, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;

  const go = (path) => {
    onClose?.();
    navigate(path);
  };

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-end md:items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full md:w-[440px] bg-white rounded-t-3xl md:rounded-3xl p-6 md:p-7 pb-[calc(24px+env(safe-area-inset-bottom))] shadow-[0_-12px_40px_rgba(0,0,0,0.3)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-nanum text-xl md:text-2xl font-bold text-stone-900">
            예약하기
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="size-8 rounded-full bg-stone-100 hover:bg-stone-200 flex items-center justify-center text-stone-600"
            aria-label="닫기"
          >
            ✕
          </button>
        </div>
        <p className="text-sm text-stone-600 mb-5">어떤 체험을 예약하시겠어요?</p>

        <div className="grid gap-3">
          <button
            type="button"
            onClick={() => go("/reservation/candleselfreservation/")}
            className="w-full flex items-center gap-4 p-4 rounded-2xl border border-stone-200 bg-stone-50 hover:bg-stone-100 transition text-left"
          >
            <span className="text-3xl">🕯️</span>
            <span className="flex-1 min-w-0">
              <span className="block font-bold text-stone-900">캔들 만들기 체험</span>
              <span className="block text-xs text-stone-500 mt-0.5">유럽 전통 양초 만들기</span>
            </span>
            <span className="text-stone-400">→</span>
          </button>

          <button
            type="button"
            onClick={() => go("/reservation/frameselfreservation/")}
            className="w-full flex items-center gap-4 p-4 rounded-2xl border border-stone-200 bg-stone-50 hover:bg-stone-100 transition text-left"
          >
            <span className="text-3xl">🌸</span>
            <span className="flex-1 min-w-0">
              <span className="block font-bold text-stone-900">프리저브드 플라워 체험</span>
              <span className="block text-xs text-stone-500 mt-0.5">시들지 않는 꽃 굿즈 만들기</span>
            </span>
            <span className="text-stone-400">→</span>
          </button>
        </div>
      </div>
    </div>
  );
}
